import constants from '../constants';

const AppActions = {
  updateApp(data) {
    return (dispatch) =>
      dispatch({
        type: constants.UPDATE_APP,
        payload: data,
      });
  },
};

export default AppActions;
